/*
    Store module mutations examples

*/
// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError(state, payload) {
  generic.clearError(state, payload)
}

export function setError(state, payload) {
  generic.setError(state, payload)
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload)
}

// Start new mutation here
export function setNotification(state, payload) {
  state.notification = payload
}

export function setNotifications(state, payload) {
  state.notifications = payload
}

export function setNotificationContracts(state, payload) {
  state.notificationContracts = payload
}

export function setNotificationCurriculumExternals(state, payload) {
  state.notificationCurriculumExternals = payload
}

export function setNotificationCall(state, payload) {
  state.notificationCall = payload
}

export function setNotificationsCall(state, payload) {
  state.notificationsCall = payload
}

export function setNotificationContractsCall(state, payload) {
  state.notificationContractsCall = payload
}

export function setNotificationCallEx(state, payload) {
  state.notificationCallEx = payload;
}

export function setNotificationsCallEx(state, payload) {
  state.notificationsCallEx = payload;
}

export function setNotificationPaymentSchedule(state, payload) {
  state.notificationPaymentSchedule = payload;
}

export function setNotificationsPaymentSchedule(state, payload) {
  state.notificationsPaymentSchedule = payload;
}

export function setNotificationPaymentSchedules(state, payload) {
  state.notificationPaymentSchedules = payload;
}

export function setNotificationContractsCallEx(state, payload) {
  state.notificationContractsCallEx = payload;
}


export function setNotificationSale(state, payload) {
  state.notificationSale = payload
}

export function setNotificationsSale(state, payload) {
  state.notificationsSale = payload
}

export function setNotificationContractsSale(state, payload) {
  state.notificationContractsSale = payload
}

export function setNotificationLawyer(state, payload) {
  state.notificationLawyer = payload
}

export function setNotificationsLawyer(state, payload) {
  state.notificationsLawyer = payload
}

export function setNotificationStudentApp(state, payload) {
  state.notificationStudentApp = payload
}

export function setNotificationsStudentApp(state, payload) {
  state.notificationsStudentApp = payload
}
